import React, { useContext, useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { Form, Button } from "react-bootstrap";
import { Formik, Field } from "formik";
import {
  DatePicker,
  SearchableList,
  FieldDropSide,
  FieldInput,
} from "../../../components";

import { useLocation } from "react-router-dom";
import {
  OPTIONS_DATA_MAPPER,
  MANAGE_PAYROLL_ROUTES,
  formFields,
  getPathWithParam,
  getFlowBasedFormValues,
  usDateFormat,
  clearFieldValues,
  toOptionValuesFromMapper,
  errors,
  manageTransactionFormNames,
  optionsinFilter,
  RECORDS_TO_FETCH,
} from "../../../utils";
import {
  manageEligibilityStore,
  managePayrollStore,
  manageTransactionStore,
  setManagePageLevelData,
  setMapperMappingData,
} from "../../../contexts";

import {
  getCompaniesList,
  getPlanList,
  getWithDrawalApprovalSearchinEmployee,
  getRollOverinApprovalSearchinEmployee,
  getLoanApprovalSearchinEmployee,
  getRollOverinDraftSearchinEmployee,
  getRolloverinApprovalSearchinEmployee,
  getWithdrawalsDraftSearchinEmployee,
} from "../../../services";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import FileStatus from "../../../mocks/fileStatus.json";
import authService from "../../../components/api-authorization/AuthorizeService";
var today = new Date();

const allOption = { label: "All", value: null };

const TransactionFilterCard = (props) => {
  const { state, dispatch } = useContext(manageTransactionStore);
  // const formName = manageTransactionFormNames.MANAGE_WITHDRWAL;
  // const fields = formFields[formName];
  const {
    setFieldValues,
    roleName,
    setLoading,
    pageRefresh,
    setPrevbtn,
    selectButtons,
    clearForm,
    dispatcher,
    fields,
    setRolloverinListEmployee,
    setWithdrawalListEmployee,
    append,
    setAppend,
    withdrawalListEmployee,
    // formName,
    values,
    apiRequest,
    setListEmployee,
    listEmployee,
    setApiRequest,
    employeeWithDrawal,
    setListEmployeeRolloverin,
    initialValues,
    setMethod,
    filter,
  } = props;

  const { flow } = useRouterParams();
  const [planList, setPlanList] = useState([]);
  const [planLoading, setPlanLoading] = useState(false);
  const location = useLocation();
  const { response: companies, loading: companyLoading } = useRequest({
    method: getCompaniesList,
    payload: 1, //TenantId, Hardcoding should be removed
    defaultResponse: [],
  });

  useDeepEffect(() => {
    setPlanLoading(true);
    getPlanList(0)
      .then((response) => {
        setPlanList(response);
        setPlanLoading(false);
      })
      .catch((error) => {
        setPlanLoading(false);
      });
  }, []);

  const onSubmit = (values, { setFieldError }) => {
    if (location.pathname.includes("manage-pending-withdrawal")) {
      setAppend(false);
      setApiRequest({
        ...apiRequest,
        companyId: values[fields.companyId],
        uniquePersonalIdentification: values[fields.employeeName],
        planId: values[fields.planId],
        searchString: values[fields.employeeName],
        requestedFrom: values[fields.requestedFrom],
        requestedTo: values[fields.requestedTo],
        orderBy: values[fields.isAscending] ? 1 : 0,
        from: 0,
        offset: RECORDS_TO_FETCH,
      });
    } else if (location.pathname.includes("manage-pending-rolloverin")) {
      setAppend(false);
      setApiRequest({
        ...apiRequest,
        companyId: values[fields.companyId],
        planId: values[fields.planId],
        requestedDateFrom: values[fields.requestedFrom],
        requestedDateTo: values[fields.requestedTo],
        employeeNameOrSSNSearch: values[fields.employeeName],
        isAscendingByRequestedDate: values[fields.isAscending],
        from: 0,
        offset: RECORDS_TO_FETCH,
      });
    } else if (location.pathname.includes("manage-pending-loan")) {
      setAppend(false);
      setApiRequest({
        ...apiRequest,
        companyId: values[fields.companyId],
        planId: values[fields.planId],
        requestedDateFrom: values[fields.requestedFrom],
        requestedDateTo: values[fields.requestedTo],
        employeeNameOrSSNSearch: values[fields.employeeName],
        isAscendingByRequestedDate: values[fields.isAscending],
        from: 0,
        offset: RECORDS_TO_FETCH,
      });
    } else if (location.pathname.includes("manage-draft")) {
      if (filter === "Withdrawals") {
        setAppend(false);
        setApiRequest({
          ...apiRequest,
          searchString: values[fields.employeeName],
          orderBy: values[fields.isAscending] ? 1 : 0,
        });
      } else if (filter === "Rolloverin") {
        setAppend(false);
        setApiRequest({
          ...apiRequest,
          from: 0,
          search: values[fields.employeeName],
          isAscending: values[fields.isAscending] ? 1 : 0,
        });
      }
    }
  };
  return (
    <Formik
      initialValues={{
        ...initialValues,
        // ...getFlowBasedFormValues(get(state, formName, {}), flow),
      }}
      onSubmit={onSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        setFieldError,
        handleSubmit,
        setValues,
        values,
        ...rest
      }) => {
        const onDaySelected = (fieldName, value) => {
          setFieldValue(fieldName, value);
        };
        const onCompanyChange = (value, plan) => {
          setValues({
            ...clearFieldValues({
              values: values,
              // fieldsToExculde: [
              //   fields.fromDate,
              //   fields.toDate,
              //   fields.fileStatus,
              // ],
              fieldsToClear: plan ? [fields.planId] : [],
            }),
            [fields.companyId]:
              value || value === 0 ? parseInt(companies[value].id) : null,
            [fields.companyName]:
              value || value === 0 ? companies[value].name : "All",
            // [fields.rkPlanNumber]: plan ? plan.rkPlanNumber : "All",
            [fields.planId]: plan ? plan.id : null,
            [fields.planName]: plan ? plan.name : "All",
          });
          setPlanLoading(true);
          getPlanList(get(companies[value], "id", 0))
            .then((response) => {
              setPlanList(response);
              setPlanLoading(false);
            })
            .catch((error) => {
              setPlanLoading(false);
              //Handle Error
            });
        };

        const onPlanChange = (value) => {
          if (value || value === 0) {
            setFieldValue(fields.planName, planList[value].name);
            setFieldValue(fields.planId, parseInt(planList[value].id));
            // setFieldValue(fields.rkPlanNumber, planList[value].rkPlanNumber);

            if (planList[value].companyId !== values[fields.companyId]) {
              const requiredCompany = companies
                .filter((val) => parseInt(val.id) === planList[value].companyId)
                .shift();
              onCompanyChange(
                companies.indexOf(requiredCompany),
                planList[value]
              );
            }
          } else {
            setFieldValue(fields.planName, "All");
            setFieldValue(fields.planId, null);
            // setFieldValue(fields.rkPlanNumber, "All");
          }
        };

        return (
          <Form
            autoComplete="off"
            // className="mb-20 mt-10"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="d-flex align-item-center pad-50-right justify-content-between">
              <div className="d-flex">
                {!location.pathname.includes("manage-draft") && (
                  <Field
                    size="xs"
                    isRequired
                    label="Company name"
                    name={fields.companyName}
                    value={values[fields.companyName]}
                    placeholder="All"
                    direction="bottom"
                    popupContent={
                      <SearchableList
                        label="Select Company"
                        options={[
                          allOption,
                          ...companies.map((company, index) => ({
                            label: company.name,
                            value: index,
                          })),
                        ]}
                        onSelect={(value) => onCompanyChange(value, null)}
                        selectedValue={values[fields.companyName]}
                      />
                    }
                    component={FieldDropSide}
                  />
                )}

                {!location.pathname.includes("manage-draft") && (
                  <div className="d-flex ml-2">
                    <Field
                      size="smdd"
                      label="Plan Name"
                      isRequired
                      name={fields.planName}
                      value={values[fields.planName]}
                      direction="bottom"
                      popupContent={
                        <SearchableList
                          label="Select Plan"
                          options={
                            planList && [
                              allOption,
                              ...planList.map((plan, index) => ({
                                label: plan.name,
                                value: index,
                              })),
                            ]
                          }
                          onSelect={(value) => onPlanChange(value)}
                          // selectedValue={values[fields.planId]}
                          selectedValue={planList.findIndex(
                            (_val) => _val.id === values[fields.planId]
                          )}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                )}

                <div className="d-flex ml-1">
                  <Field
                    size="smd"
                    isRequired
                    // style={{marginTop:"20px"}}
                    label="Employee name,SSN"
                    placeholder="Search Employee,SSN"
                    name={fields.employeeName}
                    type="text"
                    autoComplete="off"
                    value={values[fields.employeeName]}
                    onChange={handleChange}
                    component={FieldInput}
                    //component={FieldDropSide}
                  />
                </div>

                {!location.pathname.includes("manage-draft") && (
                  <div className="  ml-2 br-0">
                    <Field
                      size="sm"
                      //style={{display:"flex",flexDirecton:'column'}}
                      isRequired
                      label="Requested From"
                      name={fields.requestedFrom}
                      value={usDateFormat(values[fields.requestedFrom])}
                      isDatePicker
                      placeholder="requestedFrom"
                      direction="bottom"
                      onClear={() => onDaySelected(fields.requestedFrom, "")}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.requestedFrom, value)
                          }
                          value={usDateFormat(values[fields.requestedFrom])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                )}

                {!location.pathname.includes("manage-draft") && (
                  <div className="d-flex bl-0">
                    <Field
                      size="sm"
                      label="Requested To"
                      name={fields.requestedTo}
                      isRequired
                      placeholder="To date"
                      value={usDateFormat(values[fields.requestedTo])}
                      direction="bottom"
                      isDatePicker
                      onClear={() => {
                        onDaySelected(fields.requestedTo, "");
                        onDaySelected(fields.requestedFrom, "");
                      }}
                      onDefaultClearDisplay={values[fields.requestedTo]}
                      popupContent={
                        <DatePicker
                          onDayClick={(value) =>
                            onDaySelected(fields.requestedTo, value)
                          }
                          value={usDateFormat(values[fields.requestedTo])}
                        />
                      }
                      component={FieldDropSide}
                    />
                  </div>
                )}
              </div>
              <Button
                className="ml-2 mt-12 sort-button"
                style={{ lineHeight: "19px" }}
                variant="secondary"
                type="submit"
              >
                Search
              </Button>
            </div>

            <Field
              size="md"
              isRequired
              name={fields.isAscending}
              options={optionsinFilter}
              value={values[fields.isAscending]}
              label="Showing"
              popupContent={
                <SearchableList
                  label="Select an option"
                  isNotTypeAhead
                  options={optionsinFilter}
                  onSelect={(value, label) => {
                    setFieldValue(fields.isAscending, label);
                    // setFieldValue(fields.OrderBy, value);
                    setFieldValue(fields.isAscending, value);
                  }}
                  selectedValue={values[fields.isAscending]}
                  value={values[fields.isAscending]}
                />
              }
              // disabled={isEdit && !isSave}
              component={FieldDropSide}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default TransactionFilterCard;
